
export const ShiftBatRowType = {
    noteTimed: 'Note timed',
    note: 'Note',
    service: 'Service',
    'break': 'Break',
    breakMeal: 'Meal break',
    breakBroken: 'Broken shift break',
    location: 'Add location',
    stop: 'Point',
    stopNote: 'Stop Note',
    dead: 'Dead running',
    charter: 'Charter route',
    template: 'Template'

};
